<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">A</span><span class="epub-scb">CKNOWLEDGMENTS</span></p>
<p class="co">I would like to thank the many administrators of Southeastern Louisiana University who have supported my writing. A bill of thanks is due to my colleagues and friends for their encouragement and literary companionship. A large debt of gratitude is due the hardworking people at Sterling Lord Literistic, as well as the journal editors who have supported my work. Finally, I would like to thank my wife, Winborne, who can spot a bad sentence anywhere, anytime.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?3275f5df